import React from 'react'

const No_result = () => {
  return (
    <h1>検索結果はありませんでした。</h1>
  )
}

export default No_result